import Translation from '../../Translation';
import RichText from './RichText';
import { BasicContent } from './BasicContent';


const CMSTranslation = ({...content}) => {
  return (
    <>
      <BasicContent { ...content.copy } />
      <Translation />
      <RichText content={content.footnotes} />
    </>
  )
};

export default CMSTranslation;
